import React from "react";
import { Routes, Route } from "react-router-dom";

import Header from "./components/Header";
import Footer from "./components/Footer";

import Home from "./pages/Home";
import About from "./pages/About";
import Courses from "./pages/Courses";
import Services from "./pages/Services";
import DivineStore from "./pages/DivineStore";
import Gauseva from "./pages/Gauseva";
import Blog from "./pages/Blog";
import Spirituality from "./pages/Spirituality";
import ContactUs from "./pages/Contact";
import AstroVastu from "./pages/AstroVastu";
import Astrology from "./pages/Astrology";
import Litigation from "./pages/Litigation";
import MatchsMaking from "./pages/MatchsMaking";
import Muhurta from "./pages/Muhurta";
import WealthAstrology from "./pages/WealthAstrology";
import CareerPrediction from "./pages/CareerPrediction";
import LoveAstrology from "./pages/LoveAstrology";
import HealthAstrology from "./pages/HealthAstrology";
import CourseDetails from "./pages/CourseDetails";
import Profile from "./pages/Profile";
import Videos from "./pages/Videos";

import CareerAstrologyBlog from "./pages/blogs/CareerAstrologyBlog";
import LoveAstrologyBlog from "./pages/blogs/LoveAstrologyBlog";
import Classes from "./pages/Classes";
import DonateNow from "./pages/Donatenow";

import AdminCourses from "./pages/AdminCourses";
import Login from "./components/Login";
import Signup from "./components/Signup";
import UserDashboard from "./pages/UserDashboard";
import AdminDashboard from "./pages/AdminDashboard";

import WhatsAppIcon from "./components/WhatsAppIcon";
import CallIcon from "./components/CallIcon";
import CourseBuy from "./pages/CourseBuy";

function App() {
  return (
    <div>
      <Header />

      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/courses" element={<Courses />} />
        <Route path="/services/*" element={<Services />} />
        <Route path="/divinestore" element={<DivineStore />} />
        <Route path="/gauseva" element={<Gauseva />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/spirituality/*" element={<Spirituality />} />
        <Route path="/contact" element={<ContactUs />} />

        {/* Services */}
        <Route path="/services/astro-vastu" element={<AstroVastu />} />
        <Route path="/services/astrology" element={<Astrology />} />
        <Route path="/services/litigation" element={<Litigation />} />
        <Route path="/services/matchs-making" element={<MatchsMaking />} />
        <Route path="/services/muhurta" element={<Muhurta />} />
        <Route path="/services/wealth-astrology" element={<WealthAstrology />} />
        <Route path="/services/career-prediction" element={<CareerPrediction />} />
        <Route path="/services/love-astrology" element={<LoveAstrology />} />
        <Route path="/services/health-astrology" element={<HealthAstrology />} />
        <Route path="/services/Classes" element={<Classes />} />

        {/* Blogs */}
        <Route path="/blogs/career-astrology-blog" element={<CareerAstrologyBlog />} />
        <Route path="/blogs/love-astrology-blog" element={<LoveAstrologyBlog />} />

        {/* ✔ FIXED ROUTE FOR BUY PAGE */}
        <Route path="/buy/:id/:offerPrice" element={<CourseBuy />} />

        <Route path="/donate-now" element={<DonateNow />} />

        {/* ✔ Course Details Page */}
        <Route path="/course/:slug" element={<CourseDetails />} />

        {/* Auth */}
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />

        {/* User & Admin */}
        <Route path="/profile" element={<Profile />} />
        <Route path="/videos" element={<Videos />} />
        <Route path="/dashboard" element={<UserDashboard />} />
        <Route path="/admin/courses" element={<AdminCourses />} />
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
      </Routes>

      <WhatsAppIcon />
      <CallIcon />
      <Footer />
    </div>
  );
}

export default App;
